let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9sn3p")).then(() => parcelRequire('AFoLQ'));